import React, { SVGProps } from 'react';

const JobApplicationIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M2.33325 4.16666H13.6666C14.2189 4.16666 14.6666 4.61437 14.6666 5.16665C14.6666 5.71893 14.2189 6.16665 13.6666 6.16665H2.33325C1.78097 6.16665 1.33325 5.71893 1.33325 5.16665C1.33325 4.61437 1.78097 4.16666 2.33325 4.16666Z"
                fill="white"
            />
            <path
                d="M2.33325 0.833351H13.6666C14.2189 0.833351 14.6666 1.28107 14.6666 1.83335C14.6666 2.38563 14.2189 2.83335 13.6666 2.83335H2.33325C1.78097 2.83335 1.33325 2.38563 1.33325 1.83335C1.33325 1.28107 1.78097 0.833351 2.33325 0.833351Z"
                fill="white"
            />
            <path
                d="M12.3333 16.1667H3.66666C1.64253 16.1645 0.00221875 14.5241 0 12.5V9.83335C0 8.54466 1.04466 7.50001 2.33334 7.50001H4.66669C5.21897 7.50001 5.66669 7.94773 5.66669 8.50001C5.66669 9.42048 6.41288 10.1667 7.33334 10.1667H8.66669C9.58716 10.1667 10.3333 9.42048 10.3333 8.50001C10.3333 7.94773 10.7811 7.50001 11.3333 7.50001H13.6667C14.9553 7.50001 16 8.54466 16 9.83335V12.5C15.9978 14.5241 14.3575 16.1645 12.3333 16.1667ZM2.33334 9.50001C2.14925 9.50001 2 9.64926 2 9.83335V12.5C2 13.4205 2.74619 14.1667 3.66666 14.1667H12.3333C13.2538 14.1667 14 13.4205 14 12.5V9.83335C14 9.64926 13.8507 9.50001 13.6667 9.50001H12.1947C11.7456 11.0767 10.306 12.1648 8.66666 12.1667H7.33331C5.69397 12.1648 4.25434 11.0767 3.80531 9.50001H2.33334Z"
                fill="white"
            />
        </svg>
    );
};

export default JobApplicationIcon;
